import { useState } from "react";
import "./ProductDetails.css"
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { FiGift, FiHeart, FiShare2, FiCopy } from "react-icons/fi";
import { FiFeather, FiSun, FiDroplet } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
function ProductDetail(){
  const { slug } = useParams();
const navigate = useNavigate();
const [scent,setScent]=useState("Madurai");
const [size,setSize]=useState("Set of Two");
const [qty,setQty]=useState(1);
const [mainImg,setMainImg]=useState("");
const [openIndex, setOpenIndex] = useState(2);
const [showCartPopup, setShowCartPopup] = useState(false);
const [productData, setProductData] = useState(null);
const [selectedVariant, setSelectedVariant] = useState(0);
const [selectedProduct, setSelectedProduct] = useState(null);
const [cartProducts, setCartProducts] = useState([]);
const [zoom, setZoom] = useState(false);
const [zoomPos, setZoomPos] = useState({ x: 0, y: 0 });
 const [faqs, setFaqs] = useState([]);
const [faqLoading, setFaqLoading] = useState(false);
const [sideFaqOpen, setSideFaqOpen] = useState(0);
const [wishlistProducts, setWishlistProducts] = useState([]);
const [isMobile, setIsMobile] = useState(false);
const [showSharePopup, setShowSharePopup] = useState(false);
const [copied, setCopied] = useState(false);
useEffect(() => {
  const checkMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  checkMobile();

  window.addEventListener("resize", checkMobile);

  return () => {
    window.removeEventListener("resize", checkMobile);
  };
}, []);
const getUserGuestPayload = (createGuest = false) => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "null");
  const userId = storedUser?.id || "";
  let guestId = localStorage.getItem("guest_id") || "";

  if (!userId && createGuest && !guestId) {
    guestId = `guest_${Date.now()}`;
    localStorage.setItem("guest_id", guestId);
  }

  return userId
    ? { user_id: userId, guest_id: "" }
    : { guest_id: guestId, user_id: "" };
};
useEffect(() => {
  const fetchFaqs = async () => {
    try {
      setFaqLoading(true);

      const res = await fetch(
        "https://aethearia.store/superadmin/api/faq-list"
      );

      const data = await res.json();

      if (data.status) {
        const activeFaqs = (data.data || [])
          .filter((faq) => faq.status === "1")
          .sort(
            (a, b) =>
              Number(a.sort_order || 0) - Number(b.sort_order || 0)
          );

        setFaqs(activeFaqs);
      }
    } catch (err) {
      console.error("FAQ fetch failed:", err);
    } finally {
      setFaqLoading(false);
    }
  };

  fetchFaqs();
}, []);
const changeMainImage = (img) => {
  setMainImg(img);
  setZoom(false);
  setZoomPos({ x: 50, y: 50 });
};
const handleMouseMove = (e) => {

  const rect = e.currentTarget.getBoundingClientRect();

  const x = ((e.clientX - rect.left) / rect.width) * 100;
  const y = ((e.clientY - rect.top) / rect.height) * 100;

  setZoomPos({
    x,
    y
  });
};
const fetchCart = async () => {
  try {
    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) return;

    const res = await fetch(
      "https://aethearia.store/superadmin/api/cart-list",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      setCartProducts(data.data || []);
    } else {
      setCartProducts([]);
    }
  } catch (err) {
    console.error("Cart fetch failed:", err);
  }
};
const fetchWishlist = async () => {
  try {
    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) return;

    const res = await fetch(
      "https://aethearia.store/superadmin/api/wishlist-list",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      const ids = data.data.map((item) =>
        Number(item.product_id || item.id)
      );

      setWishlistProducts(ids);
    } else {
      setWishlistProducts([]);
    }
  } catch (err) {
    console.error("Wishlist fetch failed:", err);
  }
};

const handleAddToWishlist = async () => {
  if (isInWishlist()) return;

  const oldWishlist = [...wishlistProducts];
  const updatedWishlist = [...wishlistProducts, Number(product.id)];

  // instant wishlist UI update
  setWishlistProducts(updatedWishlist);

  // instant header count update
  window.dispatchEvent(
    new CustomEvent("cartWishlistUpdated", {
      detail: {
        wishlistCount: updatedWishlist.length,
      },
    })
  );

  try {
    const payload = {
      ...getUserGuestPayload(true),
      product_id: Number(product.id),
    };

    const res = await fetch(
      "https://aethearia.store/superadmin/api/add-to-wishlist",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      await fetchWishlist();

      setTimeout(() => {
        window.dispatchEvent(new Event("cartWishlistUpdated"));
      }, 300);
    } else {
      setWishlistProducts(oldWishlist);

      window.dispatchEvent(
        new CustomEvent("cartWishlistUpdated", {
          detail: {
            wishlistCount: oldWishlist.length,
          },
        })
      );

      alert(data.message || "Failed to add wishlist");
    }
  } catch (err) {
    console.error("Wishlist Error:", err);

    setWishlistProducts(oldWishlist);

    window.dispatchEvent(
      new CustomEvent("cartWishlistUpdated", {
        detail: {
          wishlistCount: oldWishlist.length,
        },
      })
    );
  }
};

const isInWishlist = () => {
  return wishlistProducts.includes(Number(product?.id));
};
useEffect(() => {
  fetchCart();
  fetchWishlist();
}, []);

const handleAddToCart = async () => {
  const selectedVariantData = variants?.[selectedVariant];

  if (!product?.id || !selectedVariantData?.id) {
    console.error("Product or variant missing");
    return;
  }

  if (isInCart(selectedVariantData.id)) return;

  const oldCart = [...cartProducts];

  const updatedCart = [
    ...cartProducts,
    {
      product_id: Number(product.id),
      variant_id: Number(selectedVariantData.id),
    },
  ];

  // instant cart UI update
  setCartProducts(updatedCart);

  // instant header count update
  window.dispatchEvent(
    new CustomEvent("cartWishlistUpdated", {
      detail: {
        cartCount: updatedCart.length,
      },
    })
  );

  try {
    const payload = {
      ...getUserGuestPayload(true),
      product_id: Number(product.id),
      variant_id: Number(selectedVariantData.id),
      quantity: qty,
    };

    console.log("ADD TO CART PAYLOAD:", payload);

    const res = await fetch(
      "https://aethearia.store/superadmin/api/add-to-cart",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (!data.status) {
      throw new Error(data.message || "Add to cart failed");
    }

    await fetchCart();

    setTimeout(() => {
      window.dispatchEvent(new Event("cartWishlistUpdated"));
    }, 300);

    setSelectedProduct({
      product,
      variant: selectedVariantData,
      qty,
    });

    setShowCartPopup(true);
  } catch (err) {
    console.error("Add to cart failed:", err.message);

    // rollback if API failed
    setCartProducts(oldCart);

    window.dispatchEvent(
      new CustomEvent("cartWishlistUpdated", {
        detail: {
          cartCount: oldCart.length,
        },
      })
    );
  }
};
const heroURL =
  "https://aethearia.store/superadmin/uploads/products/Hero/";

const variantURL =
  "https://aethearia.store/superadmin/uploads/products/Varient/";

const galleryURL =
  "https://aethearia.store/superadmin/uploads/products/Varient/Gallery/";

useEffect(() => {
  fetch(`https://aethearia.store/superadmin/api/product-detail/${slug}`)
    .then((res) => res.json())
    .then((data) => {
      setProductData(data.data);

      const product = data.data.product;
      const firstVariant = data.data.variants?.[0];

      // Hero image should be selected initially
      if (product?.hero_image) {
        setMainImg(heroURL + product.hero_image);
      } 
      // Fallback to variant image
      else if (firstVariant?.variant_image) {
        setMainImg(variantURL + firstVariant.variant_image);
      }
    })
    .catch((error) => {
      console.error("Product detail fetch failed:", error);
    });
}, [slug]);

if (!productData) return <div>Loading...</div>;

const product = productData.product || {};
const variants = productData.variants || [];
const selectedVariantData = variants?.[selectedVariant];

const formatNotes = (notes) => {
  if (!notes) return [];

  return String(notes)
    .split(/\r?\n/)
    .map((note) => note.trim())
    .filter(Boolean);
};

const scentFamilyText = product.scent_family?.family || "";
const waxBlendText =
  product.wax_blend?.blend ||
  product.wax_material?.wax_material ||
  "";

const fragranceOilText = product.fragrance_oil?.oil_name || "";
const ritualUseText = product.ritual_use_case || "";
const wellnessText =
  product.experience_intention ||
  product.emotional_promise ||
  "";

const petCautionText = product.pet_pregnancy_caution || "";
const fragranceNotes = formatNotes(product.notes);



const getVariantLabel = (variant) => {
  if (!variant) return "";

  if (variant.size_name) {
    return `${variant.size_name}g`;
  }

  if (variant.set_of) {
    return Number(variant.set_of) === 1
      ? "Single"
      : `Set of ${variant.set_of}`;
  }

  if (variant.colors?.length > 0) {
    return variant.colors.map((c) => c.color).join(", ");
  }

  return "Variant";
};

const currentPrice =
  Number(selectedVariantData?.offer_price) > 0
    ? Number(selectedVariantData.offer_price)
    : Number(selectedVariantData?.price || 0);
const productShareUrl =
  typeof window !== "undefined"
    ? `${window.location.origin}/product/${slug}`
    : "";

const productShareText = `${product.product_name} - ₹${currentPrice.toLocaleString(
  "en-IN"
)} | Aethearia Candle`;

const handleShareProduct = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: product.product_name,
        text: productShareText,
        url: productShareUrl,
      });
    } catch (error) {
      console.log("Share cancelled");
    }
  } else {
    setShowSharePopup(true);
  }
};

const copyProductLink = async () => {
  try {
    await navigator.clipboard.writeText(productShareUrl);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1500);
  } catch (error) {
    console.error("Copy failed:", error);
  }
};

const shareOnWhatsApp = () => {
  const url = `https://wa.me/?text=${encodeURIComponent(
    `${productShareText} ${productShareUrl}`
  )}`;

  window.open(url, "_blank");
};

const shareOnFacebook = () => {
  const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    productShareUrl
  )}`;

  window.open(url, "_blank");
};
const currentColor =
  selectedVariantData?.colors?.length > 0
    ? selectedVariantData.colors.map((c) => c.color).join(", ")
    : "";
const productAccordionDetails = [
  {
    label: "Emotional Promise",
    value: product.emotional_promise,
  },
  {
    label: "Experience Intention",
    value: product.experience_intention,
  },
  {
    label: "Fragrance Oil",
    value: product.fragrance_oil?.oil_name,
  },
  {
    label: "Wax Material",
    value: product.wax_material?.wax_material,
  },
  {
    label: "Wax Blend",
    value: product.wax_blend?.blend,
  },
  {
    label: "Wick Type",
    value: product.wick_type?.type,
  },
  {
    label: "Jar Type",
    value: product.jar_type?.type,
  },
  {
    label: "Packaging Type",
    value: product.packaging_type?.type,
  },
  {
    label: "Scent Family",
    value: product.scent_family?.family,
  },
  {
    label: "Notes",
    value: product.notes,
  },
  {
    label: "Burn Time",
    value: selectedVariantData?.burn_time,
  },
  {
    label: "Size",
    value: selectedVariantData?.size_name
      ? `${selectedVariantData.size_name}g`
      : "",
  },
].filter(
  (item) =>
    item.value !== null &&
    item.value !== undefined &&
    String(item.value).trim() !== ""
);
const isInCart = (variantId) => {
  return cartProducts.some(
    (item) =>
      Number(item.product_id) === Number(product?.id) &&
      Number(item.variant_id || item.varient_id) === Number(variantId)
  );
};

return(
<>
<Header/>

<section className="product-page">
<div className="product-wrap">

{/* LEFT */}
<div className="gallery-wrap">

  {/* THUMBNAILS (LEFT SIDE) */}
<div className="thumb-col">
    {product.hero_image && (
      <img
        src={heroURL + product.hero_image}
        alt="hero"
        className={
          mainImg === heroURL + product.hero_image
            ? "active-thumbnail"
            : ""
        }
        onClick={() =>
          changeMainImage(heroURL + product.hero_image)
        }
      />
    )}

    {variants?.[selectedVariant]?.variant_image && (
      <img
        src={variantURL + variants[selectedVariant].variant_image}
        alt="variant"
        className={
          mainImg ===
          variantURL + variants[selectedVariant].variant_image
            ? "active-thumbnail"
            : ""
        }
        onClick={() =>
          changeMainImage(
            variantURL + variants[selectedVariant].variant_image
          )
        }
      />
    )}

 {variants?.[selectedVariant]?.gallery?.map((img, i) => {
  const galleryImage = galleryURL + img.image;

  return (
    <img
      key={i}
      src={galleryImage}
      alt=""
      className={
        mainImg === galleryImage
          ? "active-thumbnail"
          : ""
      }
      onClick={() => changeMainImage(galleryImage)}
    />
  );
})}
</div>

  {/* MAIN IMAGE */}
<div
  className={`gallery-main magnifier ${zoom && !isMobile ? "zoom-active" : ""}`}
  onMouseEnter={() => !isMobile && setZoom(true)}
  onMouseLeave={() => !isMobile && setZoom(false)}
  onMouseMove={(e) => !isMobile && handleMouseMove(e)}
  style={
    !isMobile
      ? {
          backgroundImage: mainImg ? `url(${mainImg})` : "none",
          backgroundSize: zoom ? "250%" : "contain",
          backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`,
          backgroundRepeat: "no-repeat",
        }
      : {}
  }
>
  <img
    src={mainImg}
    alt={product.product_name}
  />
   {/* <img
  src={process.env.PUBLIC_URL + "/images/watermark.png"}
  alt="watermark"
  className="product-watermark-img"
/> */}
</div>

</div>

{/* RIGHT */}
<div className="product-info-card">
<h6 style={{ textTransform:"uppercase", color:"rgba(77,67,56,1)", marginBottom:"10px", fontSize:"14px", fontWeight:"100"}}>{product.category_name}</h6>
<h1 className="product-title">{product.product_name}</h1>
<p className="subtitle">{product.website_tagline}</p>

{/* {product.short_description && (
  <p className="description">
    {product.short_description}
  </p>
)} */}

<div className="product-description-section" style={{margin: "20px 0"}}>

{product.emotional_promise && (
  <div className="description">
    <strong className="description-title">
      Emotional Promise:
    </strong>

    <p>
      {product.emotional_promise}
    </p>
  </div>
)}


{product.experience_intention && (
  <div className="description">
    <strong className="description-title">
      Experience Intention:
    </strong>

    <p>
      {product.experience_intention}
    </p>
  </div>
)}

</div>

<div
  className="price1"
  style={{
    fontSize: "25px",
    fontWeight: "100",
    marginTop: "10px",
  }}
>
  ₹
  {Number(currentPrice).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}
</div>

<p className="price-note">
  MRP incl. of all taxes &{" "}
  <Link to="/shipping-policy" className="shipping-link">
    shipping
  </Link>{" "}
  calculated at checkout
</p>

<div className="product-meta1">

  {variants?.[selectedVariant]?.wax_weight && (
    <span>
      {variants[selectedVariant].wax_weight} gram |
    </span>
  )}

  {variants?.[selectedVariant]?.burn_time && (
    <span>
      {variants[selectedVariant].burn_time} 
    </span>
  )}

</div>

{variants?.length > 1 && (
  <>
    <span
      className="option-label"
      style={{
        color: "rgba(77,67,56,1)",
        fontSize: "14px",
        fontWeight: "100",
        textTransform: "uppercase",
      }}
    >
      Choose Variant
    </span>

    <div className="variant-grid">
      {variants.map((variant, index) => (
        <button
          key={variant.id}
          type="button"
          className={`variant-card ${
            selectedVariant === index ? "active" : ""
          }`}
          onClick={() => {
            setSelectedVariant(index);
            setQty(1);

            if (variant.variant_image) {
              setMainImg(variantURL + variant.variant_image);
            } else if (product?.hero_image) {
              setMainImg(heroURL + product.hero_image);
            }
          }}
        >
          <div className="variant-meta">
            <span className="variant-title">
              {getVariantLabel(variant)}
            </span>
          </div>
        </button>
      ))}
    </div>
  </>
)}

{/* {currentColor && (
  <>
    <span className="option-label" style={{ color: "rgba(77,67,56,1)", fontSize: "14px" , fontWeight:"100", textTransform:"uppercase"}}>Color</span>
    <div className="option-row">
      <button className="option-btn active">
        {currentColor}
      </button>
    </div>
  </>
)}

{product.scent_profile?.scent_profile && (
  <>
    <span className="option-label" style={{ color: "rgba(77,67,56,1)", fontSize: "14px" , fontWeight:"100", textTransform:"uppercase"}}>Scent Profile</span>
    <div className="option-row">
      <button className="option-btn active">
        {product.scent_profile.scent_profile}
      </button>
    </div>
  </>
)} */}
<div className="cart-action-row">

  <div className="qty-area">
    <span className="option-label" style={{ color: "rgba(77,67,56,1)", fontSize: "14px" , fontWeight:"100", textTransform:"uppercase"}}>Quantity</span>

    <div className="qty-box">
      <button onClick={() => qty > 1 && setQty(qty - 1)}>−</button>
      <div className="qty-num">{qty}</div>
      <button onClick={() => setQty(qty + 1)}>+</button>
    </div>
  </div>

<button
  style={{padding:0}}
  className={`cart-btn ${
    isInCart(selectedVariantData?.id) ? "added" : ""
  }`}
  disabled={isInCart(selectedVariantData?.id)}
  onClick={handleAddToCart}
>
  {isInCart(selectedVariantData?.id)
    ? "✓ Added To Cart"
    : "Add To Cart"}
</button>

</div>
<div className="wishlist-share-row">
  <button
    className={`gift-btn ${isInWishlist() ? "added" : ""}`}
    disabled={isInWishlist()}
    onClick={() => {
      if (!isInWishlist()) {
        handleAddToWishlist();
      }
    }}
  >
    <FiHeart className="gift-icon" />
    {isInWishlist() ? "Added" : "Wishlist"}
  </button>

  <button
    type="button"
    className="product-share-btn"
    onClick={handleShareProduct}
  >
    <FiShare2 className="gift-icon" />
    Share Product
  </button>
</div>

{/* <div className="feature-row">

  <div className="feature">
    <FiSun className="feature-icon" />
    <p>Hand-poured</p>
  </div>

  <div className="feature">
    <FiDroplet className="feature-icon" />
    <p>Essential oils</p>
  </div>

  <div className="feature">
    <FiGift className="feature-icon" />
    <p>Gift-ready</p>
  </div>

  <div className="feature">
    <FiFeather className="feature-icon" />
    <p>Soy wax</p>
  </div>

</div> */}

</div>

</div>

<div className="product-story-section">
  <div className="product-story-grid">

    {/* LEFT SIDE */}
    <div className="story-left">
      <div className="story-block">
        <h4> DESCRIPTION</h4>
        <p>{product.short_description}</p>
      </div>

      <div className="story-divider"></div>

      <div className="story-block">
        <h4> STORY</h4>
        <p>{product.long_scent_story}</p>
      </div>
    </div>

    {/* RIGHT SIDE */}
   <div className="story-right">

  <div className="info-item">
    <div className="info-icon-wrap">
      <img
        src={process.env.PUBLIC_URL + "/details/1.png"}
        alt="Wellness Intention"
        className="info-icon-img"
      />
    </div>
    <div>
      <h5>WELLNESS INTENTION</h5>
      <p>{wellnessText }</p>
    </div>
  </div>

  <div className="info-item">
    <div className="info-icon-wrap">
      <img
        src={process.env.PUBLIC_URL + "/details/2.png"}
        alt="Ritual Use Case"
        className="info-icon-img"
      />
    </div>
    <div>
      <h5>RITUAL USE CASE</h5>
      <p>{ritualUseText}</p>
    </div>
  </div>

  <div className="info-item">
    <div className="info-icon-wrap">
      <img
        src={process.env.PUBLIC_URL + "/details/3.png"}
        alt="Scent Family"
        className="info-icon-img"
      />
    </div>
    <div>
      <h5>SCENT FAMILY</h5>
      <p>{scentFamilyText}</p>
    </div>
  </div>

  <div className="info-item">
    <div className="info-icon-wrap">
      <img
        src={process.env.PUBLIC_URL + "/details/4.png"}
        alt="Fragrance Notes"
        className="info-icon-img"
      />
    </div>
    <div>
      <h5>FRAGRANCE NOTES</h5>

      {fragranceNotes.length > 0 ? (
        <p>
          {fragranceNotes.map((note, index) => (
            <span key={index}>
              {note}
              {index !== fragranceNotes.length - 1 && <br />}
            </span>
          ))}
        </p>
      ) : (
        <p>{fragranceOilText }</p>
      )}
    </div>
  </div>

  <div className="mini-info-row">
    <div className="mini-info">
      <div className="mini-icon-wrap">
        <img
          src={process.env.PUBLIC_URL + "/details/5.png"}
          alt="Wax Blend"
          className="mini-icon-img"
        />
      </div>
      <div>
        <h6>WAX BLEND</h6>
        <p>{waxBlendText}</p>
      </div>
    </div>

    <div className="mini-info">
      <div className="mini-icon-wrap">
        <img
          src={process.env.PUBLIC_URL + "/details/6.png"}
          alt="Suitable Room Size"
          className="mini-icon-img"
        />
      </div>
      <div>
        <h6>SUITABLE ROOM SIZE</h6>
        <p>Up to 250 sq. ft.</p>
      </div>
    </div>

    <div className="mini-info">
      <div className="mini-icon-wrap">
        <img
          src={process.env.PUBLIC_URL + "/details/7.png"}
          alt="Pet Pregnancy Caution"
          className="mini-icon-img"
        />
      </div>
      <div>
        <h6>PET/PREGNANCY CAUTION</h6>
        <p>{petCautionText || "Use caution around pets / pregnancy"}</p>
      </div>
    </div>
  </div>

</div>
  </div>

  {/* DARK CTA CARDS */}
  <div className="product-extra-cards">
  <div className="extra-card candle-care-card">
    <div className="extra-card-media">
      <img
        src={process.env.PUBLIC_URL + "/icon/8.png"}
        alt="Candle Care"
        className="extra-card-img"
      />
    </div>

    <div>
      <h4>CANDLE CARE INSTRUCTIONS</h4>
      <p>Learn how to get the best from your candle.</p>
      <button
  type="button"
  onClick={() => navigate("/takeanote")}
>
  READ GUIDE <span>→</span>
</button>
    </div>
  </div>

  <div className="extra-card shipping-card1">
    <div className="extra-card-media">
      <img
        src={process.env.PUBLIC_URL + "/icon/7.png"}
        alt="Shipping Returns"
        className="extra-card-img"
      />
    </div>

    <div>
      <h4>SHIPPING & RETURNS</h4>
      <p>Information on delivery, returns and more.</p>
      <button   type="button"
  onClick={() => navigate("/shipping-policy")}>LEARN MORE <span>→</span></button>
    </div>
  </div>
</div>

  {/* FOOTER */}
  {/* <div className="product-story-footer">
    <div className="footer-leaf">♧</div>
    <p>
      <strong>Rooted in nature. Made with intention.</strong><br />
      Handcrafted in small batches using clean ingredients and timeless rituals.
    </p>
    <div className="footer-logo">ae</div>
  </div> */}
</div>


{/* {productData?.related_products?.length > 0 && (
  <div className="related-section">

    <div className="related-head">
      <h2>You may also love</h2>
    </div>

    <div className="related-wrapper">

      <button
        className="nav-btn left"
        onClick={() => {
          document.getElementById("relatedRow").scrollBy({
            left: -320,
            behavior: "smooth",
          });
        }}
      >
        ‹
      </button>

      <div className="related-row" id="relatedRow">

        {productData.related_products.map((item) => (
          <div
            className="related-card"
            key={item.id}
            onClick={() => navigate(`/product/${item.product_slug}`)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={
                item.hero_image
                  ? heroURL + item.hero_image
                  : process.env.PUBLIC_URL + "/images/placeholder.webp"
              }
              alt={item.product_name}
            />

            <h4>{item.product_name}</h4>
            <p>Ritual Candle</p>
            <span>Rs. {item.min_price}</span>
          </div>
        ))}

      </div>

      <button
        className="nav-btn right"
        onClick={() => {
          document.getElementById("relatedRow").scrollBy({
            left: 320,
            behavior: "smooth",
          });
        }}
      >
        ›
      </button>

    </div>
  </div>
)} */}

</section>
{/* CART POPUP */}
{showCartPopup && (
  <div className="cart-popup-overlay">

    <div className="cart-popup">

      {/* CLOSE */}
      <button
        className="popup-close"
        onClick={() => setShowCartPopup(false)}
      >
        ✕
      </button>

      {/* SUCCESS */}
      <div className="popup-top">
        <span>✓</span>
        <p>Item added to your cart</p>
      </div>

      {/* PRODUCT */}
      <div className="popup-product">

        <img
  src={mainImg}
  alt={product.product_name}
/>

    {selectedProduct && (
  <div>
    <h4>{selectedProduct.product.product_name}</h4>
    <p>Scent: {product.scent_family?.family}</p>
   <span>
  ₹
  {(
    Number(selectedProduct.variant.offer_price) > 0
      ? Number(selectedProduct.variant.offer_price)
      : Number(selectedProduct.variant.price || 0)
  ).toLocaleString("en-IN")}
</span>
  </div>
)}

      </div>

      {/* BUTTONS */}
     <button
  className="view-cart-btn"
  onClick={() => navigate("/cart")}
>
  View cart ({qty})
</button>

<button
  className="checkout-btn"
  onClick={() => navigate("/checkout")}
>
  Check out
</button>

      <button
        className="continue-btn"
        onClick={() => setShowCartPopup(false)}
      >
        Continue shopping
      </button>

    </div>

  </div>
)}
{showSharePopup && (
  <div className="share-popup-overlay">
    <div className="share-popup">
      <button
        className="share-popup-close"
        onClick={() => setShowSharePopup(false)}
      >
        ✕
      </button>

      <h3>Share this product</h3>

      <p>{product.product_name}</p>

      <button
        type="button"
        className="share-option-btn whatsapp-share"
        onClick={shareOnWhatsApp}
      >
        Share on WhatsApp
      </button>

      <button
        type="button"
        className="share-option-btn facebook-share"
        onClick={shareOnFacebook}
      >
        Share on Facebook
      </button>

      <button
        type="button"
        className="share-option-btn copy-share"
        onClick={copyProductLink}
      >
        <FiCopy />
        {copied ? "Copied!" : "Copy Link"}
      </button>
    </div>
  </div>
)}
<Footer/>

</>
);
}

export default ProductDetail;